var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "d-flex w-100" },
    [
      _c(
        "div",
        { staticClass: "d-flex flex-column  w-100", attrs: { id: "boxes" } },
        [
          _c("div", { staticClass: "d-flex header-emotivi" }, [
            _c("div", { staticClass: "d-flex align-items-center" }, [
              _c("h1", [
                _vm._v(
                  _vm._s(_vm.users_total) +
                    " membre" +
                    _vm._s(_vm.users_total > 1 ? "s" : "")
                )
              ])
            ]),
            _c(
              "div",
              {
                staticClass:
                  "flex-grow-1 d-flex justify-content-end align-items-end",
                staticStyle: { "margin-top": "-40px" }
              },
              [
                _c("m-form-text", {
                  staticClass: "ml-3",
                  attrs: {
                    label: "Rechercher",
                    "label-position": "top",
                    name: "saerch",
                    autocomplete: ""
                  },
                  on: { input: _vm.loadUsers },
                  model: {
                    value: _vm.filterText,
                    callback: function($$v) {
                      _vm.filterText = $$v
                    },
                    expression: "filterText"
                  }
                }),
                _c(
                  "button",
                  {
                    staticClass: "ml-3 btn btn-sm btn-primary color-white",
                    attrs: { type: "button" },
                    on: { click: _vm.addUsers }
                  },
                  [
                    _c("icon", {
                      staticClass: "mr-2",
                      attrs: { name: "plus", scale: "1" }
                    }),
                    _vm._v(" Nouveau ")
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _c(
            "div",
            { staticClass: "flex-grow-1 overflow-hidden d-flex w-100" },
            [
              _c(
                "div",
                { staticClass: "card card-no-margin w-100" },
                [
                  _c("m-list-simple", {
                    ref: "contactslist",
                    attrs: {
                      dynamic: true,
                      items: _vm.users,
                      "item-value": "us_id",
                      "item-height": 30,
                      limit: _vm.users_limit,
                      skip: _vm.users_skip,
                      total: _vm.users_total
                    },
                    on: { itemclick: _vm.editUsers },
                    scopedSlots: _vm._u([
                      {
                        key: "ths",
                        fn: function(ref) {
                          return [
                            _c(
                              "th",
                              {
                                staticStyle: { "min-width": "50px" },
                                on: {
                                  click: function($event) {
                                    return _vm.sortItems(["us_name"])
                                  }
                                }
                              },
                              [
                                _c("span", { staticClass: "pointer" }, [
                                  _vm._v("Nom")
                                ])
                              ]
                            ),
                            _c(
                              "th",
                              {
                                on: {
                                  click: function($event) {
                                    return _vm.sortItems(["us_type"])
                                  }
                                }
                              },
                              [
                                _c("span", { staticClass: "pointer" }, [
                                  _vm._v("Type")
                                ])
                              ]
                            ),
                            _c(
                              "th",
                              {
                                on: {
                                  click: function($event) {
                                    return _vm.sortItems(["us_login"])
                                  }
                                }
                              },
                              [
                                _c("span", { staticClass: "pointer" }, [
                                  _vm._v("Email")
                                ])
                              ]
                            ),
                            _c(
                              "th",
                              {
                                on: {
                                  click: function($event) {
                                    return _vm.sortItems([])
                                  }
                                }
                              },
                              [
                                _c("span", { staticClass: "pointer" }, [
                                  _vm._v("Établissement")
                                ])
                              ]
                            ),
                            _c(
                              "th",
                              {
                                on: {
                                  click: function($event) {
                                    return _vm.sortItems(["createdAt"])
                                  }
                                }
                              },
                              [
                                _c("span", { staticClass: "pointer" }, [
                                  _vm._v("Date de création")
                                ])
                              ]
                            )
                          ]
                        }
                      },
                      {
                        key: "tds",
                        fn: function(ref) {
                          var item = ref.item
                          return [
                            _c("td", [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm._f("formatContactNameSimple")(
                                      item,
                                      "us_"
                                    )
                                  ) +
                                  " "
                              )
                            ]),
                            _c("td", [
                              _vm._v(_vm._s(_vm.getLabelUserType(item.us_type)))
                            ]),
                            _c("td", {}, [
                              _vm._v(" " + _vm._s(item.us_login) + " ")
                            ]),
                            _c("td", [
                              item.us_type !== "LATEAM"
                                ? _c(
                                    "div",
                                    _vm._l(item.establishments, function(es) {
                                      return _c("div", { key: es.es_id }, [
                                        _vm._v(_vm._s(es.es_name) + ",")
                                      ])
                                    }),
                                    0
                                  )
                                : _c("div", [_vm._v("Tous")])
                            ]),
                            _c("td", [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm
                                      .$moment(item.createdAt)
                                      .format("DD/MM/YYYY HH[H]mm")
                                  ) +
                                  " "
                              )
                            ])
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ]
          )
        ]
      ),
      _c("user-win-edit", {
        attrs: { us_id: _vm.itemSelected.us_id },
        on: { userSaved: _vm.userSaved, userCancel: _vm.userCancel },
        model: {
          value: _vm.dialog,
          callback: function($$v) {
            _vm.dialog = $$v
          },
          expression: "dialog"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }